function IsExportBatchRequestReadyToDownload(batchExportStatus) {
      return batchExportStatus === "Downloaded" || batchExportStatus === "Ready To Download"
      || batchExportStatus === "D" || batchExportStatus === "R";
    }
    
    export {IsExportBatchRequestReadyToDownload};